// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__t2AqH","col":"Table_col__E2iwO","fulfillmentStatus":"Table_fulfillmentStatus__qbxpY","emailCol":"Table_emailCol__1VW_d"};